// extracted by mini-css-extract-plugin
module.exports = {"list":"SwitchWallet_list__3QveT","wallet":"SwitchWallet_wallet__3jgaj","header":"SwitchWallet_header__2Z1dt","active":"SwitchWallet_active__CxU-G"};